import { SelectProps } from "antd";
import { generatePairs, getOneLabel, restoreOriginalObject } from "./helper";
import { formatOptions } from "../../helper";
import MultiSelect from "../../baseSelect/pc/MultiSelect";
import styles from "./style/index.module.scss";

type PropsType = {
  label: string;
  job_type_filter: any[];
  value: string[];
  boardClearText?: string;
  boardApplyFiltersText?: string;
  realTimeRefresh?: boolean;
  searchBoardPlaceholder?: string;
} & SelectProps;

const JobTypeSelectPc = ({ job_type_filter = [], value, onChange, ...rest }: PropsType) => {
  const options = formatOptions(job_type_filter, []);
  const newValue = generatePairs(value);

  const generateChangeValue = (value) => {
    const changeValue = restoreOriginalObject(value);
    onChange(changeValue, options);
  };

  const oneLabel = getOneLabel(options, value[0]);

  return (
    <MultiSelect
      options={options}
      value={newValue}
      onChange={generateChangeValue}
      visibleSearch={false}
      oneLabel={oneLabel}
      wrapperClassName={styles.languageWrapper}
      {...rest}
    />
  );
};

export default JobTypeSelectPc;
